export default [
  {
    path: '',
    name: 'p2p-offers-and-deals',
    component: () => import(/* webpackChunkName: "p2p-offersAndDeals" */ '~/views/P2POffersAndDeals/P2POffersAndDeals.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderP2P' },
    },
  },

  {
    path: 'roles',
    name: 'p2p-roles',
    component: () => import(/* webpackChunkName: "p2p-roles" */ '~/views/P2PArbitrators/P2PArbitrators.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderP2P' },
      rootRouteName: 'p2p-offers-and-deals',
    },
  },

  {
    path: 'banners',
    name: 'p2p-banners',
    component: () => import(/* webpackChunkName: "p2p-banners" */ '~/views/P2PBanners/P2PBanners.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderP2P' },
      rootRouteName: 'p2p-banners',
    },
  },
];
